import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=488794d2&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeBanner.vue?vue&type=style&index=0&id=488794d2&prod&lang=less&scoped=true"
import style1 from "./HomeBanner.vue?vue&type=style&index=1&id=488794d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488794d2",
  null
  
)

export default component.exports